import createPickerPluginViewState from 'owa-editor-picker-plugin/lib/utils/createPickerPluginViewState';
import { getGuid } from 'owa-guid';

import SonoraSuggestionsResults from '../store/schema/SonoraSuggestionsResults';
import SonoraViewState from '../store/schema/SonoraViewState';
import createSonoraHintViewState from './createSonoraHintViewState';

const createSonoraViewState = () => {
    const viewState = <SonoraViewState>{
        ...createPickerPluginViewState(),
        sessionId: getGuid(),
        sequenceId: 0,
        queryString: '',
        selectedIndex: 0,
        accepted: false,
        results: {
            clipboardSuggestions: [],
            stickyNotesSuggestions: [],
            fileSuggestions: [],
        } as SonoraSuggestionsResults,

        ...createSonoraHintViewState(),
    };

    return viewState;
};

export default createSonoraViewState;
